export default __webpack_public_path__ + "static/media/imone-img.fc9db479.webp";